import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from 'store/types';
import {TVProgramEvent} from 'utils/types';
import getTVProgramEventsThunk from 'store/tvProgramEvents/actions/getTVProgramEvents';

/**
 * Return type of the useTVProgramEvents hook
 */
type UseTVProgramEventsResult = [
  {loading: boolean; data?: TVProgramEvent[]; error?: string | boolean},
  {getTVProgramEvents: typeof getTVProgramEventsThunk}
];

/**
 * Selects the 'tvProgramEvents' state and sum it up into a referring object
 */
const tvProgramEventsSelector = (state: AppState) => ({
  loading: state.tvProgramEvents.isFetching,
  data: state.tvProgramEvents.data,
  error: state.tvProgramEvents.didInvalidate ? state.tvProgramEvents.error : false,
});

/**
 * Wraps up the business logic of selecting the 'tvProgramEvents' state.
 */

const useTVProgramEvents = (): UseTVProgramEventsResult => {
  const dispatch = useDispatch();
  const state = useSelector(tvProgramEventsSelector);

  const getTVProgramEvents = useCallback((date: Date) => dispatch(getTVProgramEventsThunk(date)), [
    dispatch,
  ]);

  return [state, {getTVProgramEvents}];
};

export default useTVProgramEvents;
